module.exports = __webpack_public_path__ + "static/media/NR.a00df6c7.svg";